// extracted by mini-css-extract-plugin
export var bottomRightDock = "_1c-0";